import { Injectable } from '@angular/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { CookieOptions } from 'express';
import { Util } from '../util/util';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  env = environment;

  private readonly techKey = this.env.cookieKey + '-token';
  private readonly techMmsKey = this.env.cookieKey + '-mmsToken';
  private readonly adminKey = this.env.adminCookieKey + '-token';
  private readonly teckTheme = this.env.cookieKey + '-ui';
  private readonly teckLang = this.env.cookieKey + '-lang';

  constructor(private cookieService: SsrCookieService) {}

  saveToken(token: string, tokenMms: string, rememberMe: boolean): void {
    const domain = Util.getDomainForCookie();
    const cookieOptions: CookieOptions = {
      expires: rememberMe ? new Date(Date.now() + 365 * 24 * 60 * 60 * 1000) : undefined,
      sameSite: 'lax',
      path: '/',
      domain: domain,
    };

    const options: { [key: string]: unknown } = {
      ...cookieOptions,
      sameSite: 'lax',
    };

    this.cookieService.set(this.techKey, token, options);
    this.cookieService.set(this.techMmsKey, tokenMms, options);
  }

  saveAdminToken(token: string): void {
    const domain = Util.getDomainForCookie();
    const cookieOptions: CookieOptions = {
      expires: undefined,
      sameSite: 'lax',
      path: '/',
      domain: domain,
    };

    const options: { [key: string]: unknown } = {
      ...cookieOptions,
      sameSite: 'lax',
    };

    this.cookieService.set(this.adminKey, token, options);
  }

  getToken(): string | null {
    return this.cookieService.get(this.techKey) || null;
  }

  getTokenMms(): string | null {
    return this.cookieService.get(this.techMmsKey) || null;
  }

  removeToken(): void {
    const domain = Util.getDomainForCookie();
    this.cookieService.delete(this.techKey, '/', domain);
    this.cookieService.delete(this.techMmsKey, '/', domain);
  }

  getAdminToken(): string | null {
    return this.cookieService.get(this.adminKey) || null;
  }

  removeAdminToken(): void {
    const domain = Util.getDomainForCookie();
    this.cookieService.delete(this.adminKey, '/', domain);
  }

  setUserTheme(theme: string): void {
    const domain = Util.getDomainForCookie();
    const cookieOptions: CookieOptions = {
      expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
      sameSite: 'lax',
      path: '/',
      domain: domain,
    };

    const options: { [key: string]: unknown } = {
      ...cookieOptions,
      sameSite: 'lax',
    };

    this.cookieService.set(this.teckTheme, theme, options);
  }

  getUserTheme(): string | null {
    return this.cookieService.get(this.teckTheme);
  }

  setUserLang(lang: string): void {
    const domain = Util.getDomainForCookie();
    const cookieOptions: CookieOptions = {
      expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
      sameSite: 'lax',
      path: '/',
      domain: domain,
    };

    const options: { [key: string]: unknown } = {
      ...cookieOptions,
      sameSite: 'lax',
    };

    this.cookieService.set(this.teckLang, lang, options);
  }

  getUserLang(): string | null {
    return this.cookieService.get(this.teckLang);
  }
}
